/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import useStore from '@store/index';
import { useProducedAddis } from '../api/post-produced-addis';

/* -------------------------------------------------------------------------- */
/*                                  Hook                                      */
/* -------------------------------------------------------------------------- */
export const useOffsetForm = () => {
	const {
		offsetCreationActiveStep,
		setOffsetCreationActiveStep,
		offsetStep2Error,
		offsetStep3Error,
		setOffsetProjectMixinAco2,
		offsetMesurabilityProjectsSelected,
	} = useStore();
	const producedAddis = useProducedAddis();

	const handleNextStepper = (
		_form: any,
		_step: number
	) => {
		_form.validate();
		const _parsedOffsetMesurabilityProjectsSelected =
			offsetMesurabilityProjectsSelected.map(
				(item: any) => ({
					[item.id]: item.quantitytco2eq * 1000000,
				})
			);

		const finalObject =
			_parsedOffsetMesurabilityProjectsSelected.reduce(
				(acc, item) => {
					const key: any = Object.keys(item)[0];
					const value = Object.values(item)[0];
					acc[key] = value;
					return acc;
				},
				{}
			);

		const bodyProducedAddis = {
			projectMixin_aco2: finalObject,
		};

		if (
			_form.isValid() &&
			offsetCreationActiveStep == 0
		) {
			setOffsetCreationActiveStep(_step);
		}
		if (
			(_form.isValid() &&
				offsetCreationActiveStep == 1 &&
				!offsetStep2Error) ||
			_step == 0
		) {
			setOffsetCreationActiveStep(_step);
			producedAddis.mutate(bodyProducedAddis);
			setOffsetProjectMixinAco2(bodyProducedAddis);
		}
		if (
			(_form.isValid() &&
				offsetCreationActiveStep == 2 &&
				!offsetStep3Error) ||
			_step == 0
		) {
			setOffsetCreationActiveStep(_step);
		}
		if (
			(_form.isValid() &&
				offsetCreationActiveStep == 3) ||
			_step == 0
		) {
			setOffsetCreationActiveStep(_step);
		}
	};

	const handleNextStepButton = (
		_form: any,
		_step: number
	) => {
		const nextStep = _step + 1;
		_form.validate();
		if (_form.isValid()) {
			setOffsetCreationActiveStep(nextStep);
		}
	};

	const handlePreviousStepButton = () => {
		if (offsetCreationActiveStep > 0)
			setOffsetCreationActiveStep(
				offsetCreationActiveStep - 1
			);
	};

	return [
		handleNextStepper,
		handleNextStepButton,
		handlePreviousStepButton,
	] as const;
};
